import React from 'react'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Textarea } from '@/Components/ui/textarea'

const CodingPostProblem = ({ form, event, updateEvent }) => {
    return (
        <div>
            <div className="grid grid-cols-2 gap-y-3 gap-x-6 mt-5">
                <FormField
                    control={form.control}
                    name="clinician_name"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Clinician Name</FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Clinician Name"
                                    value={event.work_allocation.clinician_name}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                clinician_name: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    clinician_name: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <div></div>
                <FormField
                    control={form.control}
                    name="query"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Query1</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query"
                                    value={event.work_allocation.question1}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                question1: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    question1: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query_answer"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Query1 Answer</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query Answer"
                                    value={event.work_allocation.answer1}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                answer1: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    answer1: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="query"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Query2</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query"
                                    value={event.work_allocation.question2}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                question2: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    question2: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query_answer"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Query2 Answer</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query Answer"
                                    value={event.work_allocation.answer2}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                answer2: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    answer2: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Query3</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query"
                                    value={event.work_allocation.question3}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                question3: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    question3: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query_answer"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>Query3 Answer</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query Answer"
                                    value={event.work_allocation.answer3}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                answer3: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    answer3: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
            </div>
            <hr className="my-5" />
            <div className="grid grid-cols-2 gap-y-3 gap-x-6 mt-5">
                <FormField
                    control={form.control}
                    name="tioc_query"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>TIOC Query1</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="TIOC Query"
                                    value={event.work_allocation.tioc_query}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                tioc_query: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    tioc_query: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="tioc_query_answer"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>TIOC Query Answer1</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="TIOC Query Answer"
                                    value={event.work_allocation.tioc_query_answer}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                tioc_query_answer: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    tioc_query_answer: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>TIOC Query2</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query"
                                    value={event.work_allocation.tioc_query2}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                tioc_query2: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    tioc_query2: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query_answer"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>TIOC Query Answer2</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query Answer"
                                    value={event.work_allocation.tioc_query_answer2}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                tioc_query_answer2: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    tioc_query_answer2: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>TIOC Query3</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query"
                                    value={event.work_allocation.tioc_query3}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                tioc_query3: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    tioc_query3: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="query_answer"
                    render={({ field }) => (
                        <FormItem className="space-y-1">
                            <FormLabel>TIOC Query Answer3</FormLabel>
                            <FormControl>
                                <Textarea
                                    type="text"
                                    className=" focus-visible:ring-transparent space-0 mt-0 text-security"
                                    placeholder="Query Answer"
                                    value={event.work_allocation.tioc_query_answer3}
                                    onChange={(e) => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.work_allocation,
                                                tioc_query_answer3: e.target.value,
                                            },
                                            update_obj: {
                                                name: event.work_allocation.name,
                                                data: {
                                                    tioc_query_answer3: e.target.value,
                                                },
                                            },
                                        })
                                    }}
                                />
                            </FormControl>
                        </FormItem>
                    )}
                />
            </div>
        </div>
    )
}

export default CodingPostProblem
